import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/allCampaings.actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.CLEAN_All_CAMPAING:
      return []
    case Actions.ADD_All_CAMPAING:
       return [...state, action.allCampaings]
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}